"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DumpsterActivityRecordTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const address_transport_1 = require("../../common/address-transport");
const nullable_1 = require("../../common/nullable");
const activity_record_transport_1 = require("../activity-record-transport");
exports.DumpsterActivityRecordTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    locationClass: activity_record_transport_1.LocationClass,
    address: typebox_1.Type.Optional((0, nullable_1.Nullable)(address_transport_1.AddressTransport)),
    coordinates: typebox_1.Type.Object({
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
    forOrderID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
});
//# sourceMappingURL=dumpster-activity-record-transport.js.map